export const ErrorBox = ({ error }: { error: string }) => {
	return (
		<div className="max-w-2xl mx-auto py-8">
			<div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
				<p className="font-bold">Error:</p>
				<p>{error}</p>
			</div>
		</div>
	);
};
